import * as vp from 'vopay';
import { FunctionComponent, useContext, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { DialogueHandler, PushToCardDialogueHandler } from './types';
import PushToCardContext from './PushToCardContext';

const { ConfirmationDialogue } = vp;

type PushToCardDialogueProps = {
  handleDialogue: DialogueHandler<PushToCardDialogueHandler>;
};

type FC = FunctionComponent<PushToCardDialogueProps>;

const PushToCardDialogue: FC = ({ handleDialogue }: PushToCardDialogueProps) => {
  const { showPushToCardSuccessAlert, showPushToCardErrorAlert, pushToCardError } = useContext(PushToCardContext);
  const { t } = useTranslation('translations', { keyPrefix: 'DebitCardDialouge' });

  return useMemo(
    () => (
      <div>
        {/* Push to Card Connection Success */}
        <ConfirmationDialogue
          isVisible={showPushToCardSuccessAlert}
          title={`${t('successfullMsg')}`}
          status="success"
          subTitle=""
          confirm={{
            label: `${t('doneButton')}`,
            action: () => handleDialogue({ type: 'connect', state: 'success' }),
          }}
        />
        {/* Push to Card Connection Fail */}
        <ConfirmationDialogue
          isVisible={showPushToCardErrorAlert}
          title={
            <>
              {pushToCardError === 'DECLINED' ? `${t('declinedCreditCardError')}` : `${t('incorrectInfomrationError')}`}
            </>
          }
          variant="creditCard"
          status="fail"
          buttonColor="primary"
          buttonTextColor="white"
          subTitle={<>{pushToCardError === 'DECLINED' ? '' : pushToCardError}</>}
          confirm={{
            label: `${t('backButton')}`,
            action: () => handleDialogue({ type: 'connect', state: 'fail' }),
          }}
        />
      </div>
    ),
    [showPushToCardSuccessAlert, showPushToCardErrorAlert, pushToCardError],
  );
};

export default PushToCardDialogue;
